import * as React from "react";
import Helmet from "react-helmet";
import axios from "axios";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import Loading from "../../components/Loading";
import { Wrap } from "../../components/Layout/Page";

import NotFound from "../../containers/NotFound/NotFound";
import { EditAction } from "../../components/Action/EditAction";
import {
  saveAction,
  loadActionForEditing,
} from "../../redux/modules/action/actionCreators";

interface StateProps {
  user: Insite.AppState["auth"]["user"];
  appSetupComplete: boolean;
  isLoading: boolean;
  isRulesLoading: boolean;
  isPending: boolean;
  submitError: string;
  action?: Insite.API.Action;
  rules: string[];
  urlHistory: Insite.AppState["urlHistory"];
}

interface DispatchProps {
  requestAction: typeof loadActionForEditing;
  requestSave: typeof saveAction;
}

interface State {
  assignees: Insite.Assignee[];
}

function mapStateToProps({
  betaAction,
  appSetup,
  auth,
  urlHistory,
}: Insite.AppState): StateProps {
  return {
    user: auth.user,
    appSetupComplete: appSetup.appSetupComplete,
    isLoading: betaAction.isLoading,
    isRulesLoading: betaAction.isRulesLoading,
    isPending: betaAction.isPending,
    submitError: betaAction.submitError,
    action: betaAction.action,
    rules: betaAction.rules,
    urlHistory,
  };
}

const mapDispatchtoProps: DispatchProps = {
  requestAction: loadActionForEditing,
  requestSave: saveAction,
};

type Props = StateProps &
  DispatchProps &
  RouteComponentProps<{ actionId: string }>;
class EditActionScene extends React.Component<Props, State> {
  static defaultProps = {
    action: undefined,
    rules: [],
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      assignees: [],
    };
  }

  componentDidMount() {
    if (this.props.appSetupComplete) {
      const { match } = this.props;
      this.props.requestAction(match.params.actionId);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { appSetupComplete, isLoading, action, match } = this.props;
    if (appSetupComplete && !isLoading && action === undefined) {
      this.props.requestAction(match.params.actionId);
    }

    // Fetch the assignee list if everything has finished loading and an action exists
    if (action !== undefined && prevProps.action !== action) {
      this.requestAssignees(action.project_key);
    }
  }

  requestAssignees = async (projectKey: string) => {
    // NOTE: null assertion as this isn't called until after props.action exists
    // tslint:disable-next-line: no-floating-promises
    const { data }: { data: State["assignees"] } = await axios.get(
      `/hashtagUsernamelist/${projectKey}/${this.props.action!.components}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );
    this.setState({ assignees: data });
  };

  render() {
    const {
      user,
      action,
      rules,
      appSetupComplete,
      isLoading,
      isRulesLoading,
      isPending,
      submitError,
      requestSave,
      urlHistory,
    } = this.props;

    if (!appSetupComplete || isLoading || isRulesLoading) {
      return (
        <Wrap>
          <Loading />
        </Wrap>
      );
    }

    if (!isLoading && action === undefined) {
      return (
        <Wrap>
          <NotFound />
        </Wrap>
      );
    }

    return (
      <Wrap>
        <Helmet title="Edit Action" />
        <EditAction
          rules={rules}
          assignees={this.state.assignees}
          equips={action!.associatedEquips}
          onSave={requestSave}
          action={action!} // TODO: This null assertion shouldn't be necessary
          isPending={isPending}
          submitError={submitError}
          urlHistory={urlHistory}
          userGroups={user.groups!}
        />
      </Wrap>
    );
  }
}

const connected = connect(mapStateToProps, mapDispatchtoProps)(EditActionScene);
export { connected as EditActionScene };
